module.exports = __webpack_public_path__ + "static/istikbal-sm-acbcf1bfc88994568419911dc8fc5b8f.jpg";